"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeaturedLiveSkeleton = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _css = _interopRequireDefault(require("@styled-system/css"));

var _Layout = require("../Layout");

var StyledFinalGridRow = (0, _styledComponents.default)(_Layout.GridItem).withConfig({
  displayName: "FeaturedLiveSkeleton__StyledFinalGridRow",
  componentId: "u4dhio-0"
})((0, _css.default)({
  visibility: ['visible', 'hidden']
}));

var FeaturedLiveSkeleton = function FeaturedLiveSkeleton(_ref) {
  var color = _ref.color;
  return _react.default.createElement(_Layout.Grid, {
    gridRowGap: 3
  }, _react.default.createElement(_Layout.GridItem, {
    gridRow: 1
  }, _react.default.createElement(_Layout.Grid, {
    gridRowGap: [4, 0],
    gridColumnGap: 3,
    gridTemplateColumns: "40px 1fr"
  }, _react.default.createElement(_Layout.GridItem, {
    gridRow: [2, 1],
    gridColumn: 1
  }, _react.default.createElement(_Layout.Box, {
    backgroundColor: color,
    height: "40px",
    width: "40px",
    style: {
      borderRadius: '50%'
    }
  })), _react.default.createElement(_Layout.GridItem, {
    gridRow: [2, 1],
    gridColumn: 2
  }, _react.default.createElement(_Layout.Grid, {
    gridRowGap: 3
  }, _react.default.createElement(_Layout.GridItem, {
    gridRow: 1
  }, _react.default.createElement(_Layout.Box, {
    backgroundColor: color,
    paddingTop: 4,
    width: "124px",
    borderRadius: 3
  })), _react.default.createElement(_Layout.GridItem, {
    gridRow: 2
  }, _react.default.createElement(_Layout.Box, {
    backgroundColor: color,
    paddingTop: 4,
    width: "180px",
    borderRadius: 3
  })))), _react.default.createElement(_Layout.GridItem, {
    gridRow: 1,
    gridColumn: [1, 3]
  }, _react.default.createElement(_Layout.Grid, {
    gridColumnGap: [3, 4],
    marginTop: [0, '-8px']
  }, _react.default.createElement(_Layout.GridItem, {
    gridRow: 1,
    gridColum: 1
  }, _react.default.createElement(_Layout.Box, {
    backgroundColor: color,
    paddingTop: 4,
    width: "74px",
    borderRadius: 3
  })), _react.default.createElement(_Layout.GridItem, {
    gridRow: 1,
    gridColum: 2
  }, _react.default.createElement(_Layout.Box, {
    backgroundColor: color,
    paddingTop: 4,
    width: "104px",
    borderRadius: 3
  })))))), _react.default.createElement(_Layout.GridItem, {
    gridRow: 2
  }, _react.default.createElement(_Layout.Box, {
    backgroundColor: color,
    paddingTop: 4,
    width: "100%",
    borderRadius: 3
  })), _react.default.createElement(StyledFinalGridRow, {
    gridRow: 3
  }, _react.default.createElement(_Layout.Box, {
    backgroundColor: color,
    paddingTop: 4,
    width: "180px",
    borderRadius: 3
  })));
};

exports.FeaturedLiveSkeleton = FeaturedLiveSkeleton;